import { Builder } from '@builder.io/react';

import { SummitHero } from './index';

Builder.registerComponent(SummitHero, {
  name: 'Summit Hero',
  inputs: [
    {
      name: 'dates',
      type: 'string',
      defaultValue: 'NOVEMBER 1ST - 3RD, 2023'
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Title'
    },
    {
      name: 'paragraphs',
      type: 'list',
      subFields: [
        {
          name: 'paragraph',
          type: 'string'
        }
      ],
      defaultValue: []
    }
  ]
});
